import { Component } from '@angular/core';

@Component({
  selector: 'mom-banner-skeleton',
  templateUrl: 'banner-skeleton.component.html',
  styleUrls: ['./banner-skeleton.component.scss']
})
export class BannerSkeletonComponent {}
